import request from '@/utils/request'

/**
 * 查询设备元件
 * @param {Object} params
 * @returns
 */
export function listDeviceModelDefinition(params) {
  return request({
    url: '/model_definition/device_definition/list',
    method: 'GET',
    params
  })
}

/**
 * 添加设备元件
 * @param {Object} data
 * @returns
 */
export function addDeviceModelDefinition(data) {
  return request({
    url: '/model_definition/device_definition/insert',
    method: 'POST',
    data
  })
}

/**
 * 修改设备元件
 * @param {Object} data
 * @returns
 */
export function updateDeviceModelDefinition(data) {
  return request({
    url: '/model_definition/device_definition/update',
    method: 'POST',
    data
  })
}

/**
 * 删除
 * @param {Object} data
 * @returns
 */
export function removeDeviceModelDefinition(data) {
  return request({
    url: '/model_definition/device_definition/remove',
    method: 'POST',
    data
  })
}

/**
 * 添加设备元件
 * @param {Object} data
 * @returns
 */
export function getDeviceModelDefinitionById(data) {
  return request({
    url: '/model_definition/device_definition/getById',
    method: 'get',
    data
  })
}
